module.exports = function() {
  return new Worker(__webpack_public_path__ + "b8bb8b49a48152df662a.worker.js");
};